import { lazy } from 'react';
import { Route } from 'react-router-dom';

import { RequireRole } from '@/core/permissions';

const ApiKeysPage = lazy(() =>
  import('./pages/ApiKeysPage').then(m => ({ default: m.ApiKeysPage }))
);

/**
 * `/settings/api-keys`, gated exactly like the API: `HasSchoolRole("admin",
 * "teacher")` on both `/api/school-api-keys/` and `/api/mcp-activity/`.
 *
 * A pupil or a parent can never own a machine credential (backend ADR-023 —
 * the key can never exceed its owner's role, so handing one to a child would
 * be the only way to raise that ceiling), which is why the guard is not the
 * four-role list the other read screens carry.
 */
export const apiKeyRoutes = (
  <Route element={<RequireRole roles={['admin', 'teacher']} />}>
    <Route path="/settings/api-keys" element={<ApiKeysPage />} />
  </Route>
);
